var _circle, _g, _circle2, _circle3, _ellipse, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredIntWireIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#DFE2EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4761_14680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.114 31.9429C23.6584 42.1763 31.2407 44.9097 35.0669 44.4959L31.0022 35.8702L19.114 31.9429Z",
    fill: "#DFE2EB",
    stroke: "#00193C",
    strokeWidth: 1.13725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0678 37.8598C27.9436 44.1177 34.1781 45.0117 37.6112 44.2904C42.7615 43.6189 48.7626 38.4733 53.1449 33.7558C54.467 32.3326 55.6417 30.9483 56.6013 29.7376C57.1204 29.0827 56.749 28.12 55.9412 27.9058C54.6662 27.5677 53.423 27.1416 52.2327 26.6634C49.3242 25.4946 46.7318 24.014 44.7645 22.7426C43.5252 21.9417 42.534 21.2238 41.8679 20.7191C41.3442 20.3224 40.5868 20.4181 40.1779 20.9323C39.3551 21.9671 38.3461 23.1134 37.174 24.2558C33.9049 27.4421 29.3676 30.5976 24.0672 31.2158C23.0517 31.3342 22.0083 31.3596 20.9404 31.2741C19.8574 31.1875 19.2173 32.3016 20.1318 32.8882C20.8792 33.3677 21.7049 33.7935 22.5664 34.1706C22.5737 34.174 22.5811 34.1773 22.5885 34.1803C24.7862 35.1396 27.2141 35.783 29.1697 36.1941C29.9047 36.3486 30.3092 37.1486 30.0678 37.8598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2327 26.6634C53.423 27.1416 54.6662 27.5677 55.9412 27.9058C56.749 28.12 57.1204 29.0827 56.6013 29.7376C55.6417 30.9483 54.467 32.3326 53.1449 33.7558M52.2327 26.6634C50.5746 28.1078 48.4357 31.5485 53.1449 33.7558M52.2327 26.6634C49.3242 25.4946 46.7318 24.014 44.7645 22.7426M53.1449 33.7558C48.7626 38.4733 42.7615 43.6189 37.6112 44.2904C34.1781 45.0117 27.9436 44.1177 30.0678 37.8598C30.3092 37.1486 29.9047 36.3486 29.1697 36.1941C27.2076 35.7816 24.7699 35.1353 22.5664 34.1706M44.7645 22.7426C43.5252 21.9417 42.534 21.2238 41.8679 20.7191C41.3442 20.3224 40.5868 20.4181 40.1779 20.9323C39.3551 21.9671 38.3461 23.1134 37.174 24.2558M44.7645 22.7426C43.5919 24.7549 40.4322 27.8748 37.174 24.2558M37.174 24.2558C33.9049 27.4421 29.3676 30.5976 24.0672 31.2158M24.0672 31.2158C23.0517 31.3342 22.0083 31.3596 20.9404 31.2741C19.8574 31.1875 19.2173 32.3016 20.1318 32.8882C20.8792 33.3677 21.7049 33.7935 22.5664 34.1706M24.0672 31.2158C25.568 32.4305 23.4575 34.5855 22.5664 34.1706",
    stroke: "#00193C",
    strokeWidth: 1.13725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7537 31.0317C32.896 32.8069 32.7413 35.5214 34.2454 37.0953C35.7495 38.6692 38.4682 38.6377 40.3258 36.8624C42.1835 35.0872 42.3383 32.3727 40.8342 30.7988C39.33 29.2249 36.6114 29.2564 34.7537 31.0317Z",
    fill: "white",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8674 35.0249C39.3863 34.506 39.489 33.7673 39.0967 33.375C38.7044 32.9827 38.0732 32.9779 37.4468 33.6043C36.8204 34.2307 36.1892 34.2259 35.797 33.8336C35.4047 33.4413 35.5073 32.7026 36.0262 32.1837M38.8674 35.0249C38.5196 35.3726 38.0732 35.5334 37.6984 35.4836M38.8674 35.0249L39.2225 35.38M36.0262 32.1837L35.6711 31.8286M36.0262 32.1837C36.374 31.836 36.8205 31.6751 37.1952 31.725",
    stroke: "#0E5CF4",
    strokeWidth: 1.13725,
    strokeLinecap: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.36,
    cy: 46.36,
    r: 10.9,
    fill: "#0E5CF4",
    stroke: "#20242E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.36,
    cy: 46.36,
    r: 6.84,
    fill: "white",
    stroke: "#13151A",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3599,
    cy: 46.36,
    rx: 3.42,
    ry: 6.84,
    fill: "white",
    stroke: "#13151A",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.52 46.36H53.2",
    stroke: "#13151A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4761_14680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.52,
    height: 41.04,
    fill: "white",
    transform: "translate(18.2402 16.72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredIntWireIn);
export default __webpack_public_path__ + "static/media/ic-colored-int-wire-in.2e912b8ce3799e81ae3969c0d6c9fd8f.svg";
export { ForwardRef as ReactComponent };